<template>
  <form action="" class="row border-bottom my-2" style="overflow-y: scroll; max-height: 14rem;" @submit.prevent="">
    <div class="col-sm-12 col-md-4 col-lg-3" v-for="(col, idx) of columnConfig" :key="idx">
      <div class="input-group mb-1" v-if="col.permission ? appStore.currentUser.hasPermission(col.permission) : true">
        <div class="input-group-prepend">
          <button class="btn btn-outline-secondary" type="button" @click="toggleVisible(col)" :title="'Show/Hide column'">
            <font-awesome-icon :icon="['fas', 'eye']" v-if="col.isVisible" />
            <font-awesome-icon :icon="['fas', 'eye-slash']" v-else />
          </button>
          <button class="btn btn-outline-secondary" type="button"  @click="toggleFrozen(col)" :title="'Freeze/Unfreeze column'">
            <font-awesome-icon :icon="['fas', 'lock']" v-if="col.isFrozen" />
            <font-awesome-icon :icon="['fas', 'lock-open']" v-else />
          </button>
        </div>
        <input type="text" readonly class="form-control" :value="col.header">
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { TableColumn } from '@/src/models/dashboard/table-column';
import ActionToolbar from '../../shared/ActionToolbar.vue';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { useAppCoreStore } from "@/src/stores/app-core";

export default {
  components: {
    DataTable,
    Column,
    ActionToolbar
  },
  props: {
    tableColumns: {
      type: Array<TableColumn>,
      required: true
    }
  },
  emits: ['configSaved'],
  mixins: [savableStateMixin],
  watch: {
    tableColumns: {
      handler(newVal: Array<TableColumn>) {
        this.columnConfig = this.createLocalTableColumns(newVal);
      },
      deep: true
    }
  },
  setup() {
    const appStore = useAppCoreStore();
    return {
      appStore
    }
  },
  data() {
    return {
      columnConfig: (this.createLocalTableColumns(this.tableColumns || []))
    }
  },
  methods: {
    toggleVisible(col: TableColumn) {
      col.isVisible = !col.isVisible;
      this.emitConfigSaved();
    },
    toggleFrozen(col: TableColumn) {
      col.isFrozen = !col.isFrozen;
      this.emitConfigSaved();
    },
    createLocalTableColumns(input: Array<TableColumn>): Array<TableColumn> {
      return input.sort((c1, c2) => c1.position - c2.position ).map((c) => {
        return new TableColumn({ ...c });
      });
    },
    emitConfigSaved() {
      this.$emit('configSaved', this.columnConfig);
    }
  }
}
</script>